import { useMemo } from 'react';
import { CUSTOMER_FILTERABLE_FIELDS } from '@vy/customers-types';
import { CUSTOM_FIELD_ENTITIES } from '@vy/custom-fields-types';
import { MONGO_FILTER_OPERATORS } from '@vy/types';
import { useCustomFieldDefinitions } from '../../../../hooks/requests/use-custom-field-definitions';
import { useLabels } from '../../../../hooks/requests/use-labels';
import type { FilterField } from '../../../../components/new-design/vyTableFilter';
import { CUSTOMERS_FILTER_FIELDS } from '../customers-page-utils/filter-fields-utils';
import { customFieldDefinitionToFilterField } from '../../../../utils/custom-field-filter-utils';

export function useCustomersFilterFields(): FilterField[] {
  const { data: labelsData } = useLabels();
  const { data: customFieldDefinitionsData } = useCustomFieldDefinitions();

  return useMemo((): FilterField[] => {
    const labelsOptions = (labelsData?.labels ?? []).map((label) => ({
      value: label.id,
      label: label.name,
    }));

    const labelsField: FilterField | undefined =
      labelsOptions.length === 0
        ? undefined
        : {
            id: CUSTOMER_FILTERABLE_FIELDS.LABELS,
            label: 'Labels',
            inputType: 'select',
            operators: [
              { label: 'Is any of', value: MONGO_FILTER_OPERATORS.HAS_SOME },
              { label: 'Is not any of', value: MONGO_FILTER_OPERATORS.HAS_NONE },
            ],
            options: labelsOptions,
          };

    const allDefinitions = customFieldDefinitionsData?.customFieldDefinitions ?? [];
    const customerCustomFieldFilters: FilterField[] = allDefinitions
      .filter((d) => d.vayuEntity === CUSTOM_FIELD_ENTITIES.CUSTOMER)
      .map((d) => customFieldDefinitionToFilterField(d, `customFieldValues.${d.vayuCustomFieldName}`));

    return [
      ...CUSTOMERS_FILTER_FIELDS,
      ...(labelsField ? [labelsField] : []),
      ...customerCustomFieldFilters,
    ];
  }, [labelsData, customFieldDefinitionsData]);
}
